import tribuneA from "./tribuneA";
import tribuneB from "./tribuneB";
import tribuneE from "./tribuneE";
import tribuneF from "./tribuneF";
import tribuneERE from "./tribuneERE";

export default {
  AA: tribuneA,
  AB: tribuneB,
  E: tribuneE,
  F: tribuneF,
  ERE: tribuneERE
}